import ApexCharts from 'apexcharts'

window.addEventListener('load', (event) => {
    const ctx = document.getElementById('rfpChart');

    if (ctx) {

        var options = {
            series: [{
                name: 'RFPs',
                data: window.chartJson.counts
            }],
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    borderRadius: 10,
                    dataLabels: {
                        position: 'top', // top, center, bottom
                    },
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return val;
                },
                offsetY: -20,
                style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                }
            },

            xaxis: {
                categories: window.chartJson.dates,
                position: 'bottom',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    fill: {
                        type: 'gradient',
                        gradient: {
                            colorFrom: '#D8E3F0',
                            colorTo: '#BED1E6',
                            stops: [0, 100],
                            opacityFrom: 0.4,
                            opacityTo: 0.5,
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                },
                labels: {
                    rotate: -45
                },
                title: {
                    text: 'Week Commencing',
                    style: {
                        fontSize: '16px',
                    }
                }
            },
            yaxis: {
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false,
                },
                labels: {
                    show: false,
                    formatter: function (val) {
                        return val;
                    }
                }

            },
            title: {
                text: 'Recently Created RFPs',

                align: 'center',
                style: {
                    fontSize: '24px',
                    color: '#444'
                }
            }
        };
        var chart = new ApexCharts(ctx, options);

        chart.render();
    }
});
